
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppButton } from '@/components';
import { AppFileUpload, AppImageHolder, AppSimpleTable } from '@/components';
import { Options, DisplayType } from '@/modules/promotion/item/model/mixins';
import { usePromotionItemAdd } from '@/modules/promotion/item/model/add';
import { promotionService } from '@/services/promotion';
import { ROUTE_NAME_PROGRESS } from '@/modules/progress/router';
import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';

export default defineComponent({
    name: ROUTE_NAME_PROGRESS.PROMOTION.ADD,
    components: { AppFormRow, AppInput, AppCard, AppFileUpload, AppImageHolder, AppSelect, AppSimpleTable, AppButton },
    setup() {
        const router = useAppRouter();

        const { model, v$, fetch, appSelectOptions } = usePromotionItemAdd();

        const create = useCrudActions().excuteAndNotify({
            validator: v$,
            request: () =>
                promotionService.item.create(
                    model.name,
                    model.cloneId,
                    model.cloneId ? model.forAppId : null,
                    model.fromTime?.getTime(),
                    model.toTime?.getTime(),
                    model.displayType,
                    model.expectedPackage,
                    model.prototypeId,
                    model.imageFile
                ),
            onSuccess: () => router.push({ name: ROUTE_NAME_PROGRESS.PROMOTION.INDEX })
        });

        onMounted(async () => {
            model.displayType = DisplayType.AccessUnlimited.value;
            await fetch();
        });

        return { v$, model, create, appSelectOptions, Options, DisplayType };
    }
});
